import { useState, useEffect } from 'react';
import { getDailyRevenueData } from '../services/orderService';

interface RevenueTrendData {
  date: string;
  revenue: number;
  orders: number;
}

interface UseRevenueTrendResult {
  data: RevenueTrendData[];
  loading: boolean;
  error: string | null;
  refresh: () => Promise<void>;
}

export const useRevenueTrend = (): UseRevenueTrendResult => {
  const [data, setData] = useState<RevenueTrendData[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);
      const revenueData = await getDailyRevenueData();
      setData(revenueData);
    } catch (err) {
      console.error('Error fetching revenue trend data:', err);
      setError('Failed to load revenue trend data');
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const refresh = async () => {
    await fetchData();
  };

  useEffect(() => {
    fetchData();
  }, []);

  return {
    data,
    loading,
    error,
    refresh
  };
}; 